module.exports = __webpack_public_path__ + "static/media/h2.f797c3d3.jpg";